import React from 'react'
import { WidgetContent, WidgetTable } from '@duik/it'
import styled from '@emotion/styled'

const StyledWidgetContent = styled(WidgetContent)`
  padding: 0;
  height: calc(100vh - 228px);
  overflow: auto;
`

const StyledWidgetTable = styled(WidgetTable)`
  position: relative;
`

type Props = {
  children?: any
}

const TableSection = ({ children }: Props) => (
  <StyledWidgetContent>
    <StyledWidgetTable>{children}</StyledWidgetTable>
  </StyledWidgetContent>
)

export default TableSection
